import { FeatureFlag } from "@common-shared/config/featureFlags.config"

import { PrimaryText } from "@front-shared/elements/primaryText.element"

import { GENERAL_CONFIG } from "../../config/general.config"
import { useIsFeatureFlagEnabled } from "../../hooks/isFeatureFlagEnabled.hook"

export const OutageBannerComponent: React.FC = () => {
    const flagEnabled = useIsFeatureFlagEnabled(
        FeatureFlag.ONE_VERIFY_OUTAGE_BANNER,
    )

    return flagEnabled ? (
        <div className="w-full border-b-2 px-[45px] py-[24px] mb-[24px] bg-brand-error border-brand-error">
            <PrimaryText
                typography="textSemibold"
                className="text-white break-words"
            >
                Some customers may be experiencing a technical issue that
                impacts running verifications. We&apos;re actively working on a
                resolution. If you have questions, reach out to{" "}
                <a href={`mailto:${GENERAL_CONFIG.supportEmail}`}>
                    {GENERAL_CONFIG.supportEmail}
                </a>
                .
            </PrimaryText>
        </div>
    ) : null
}
